import { render } from "./OrderBook.vue?vue&type=template&id=059553f2"
import script from "./OrderBook.vue?vue&type=script&lang=js"
export * from "./OrderBook.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__